var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"button-type":"tagSecondary","size":"small"},on:{"click":function($event){return _vm.$router.push({ name: 'genre', params: { id: _vm.id } })}}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.genre)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }